<template>
  <div class="mb-6">
    <v-skeleton-loader class="mx-auto" type="table" v-show="showSkeleton" />
    <div v-show="!showSkeleton">
      <v-expansion-panels multiple class="mb-1" focusable v-for="(queue, i) in arrayInfoQueues" :key="i">
        <v-expansion-panel class="mt-2 mb-2">
          <v-expansion-panel-header>
            <template v-slot:default="{ open }">
              <div>
                <v-row justify>
                  <v-col>
                    <div class="title-operators pb-1 mt-n2">{{ queue.fila_description }}</div>
                  </v-col>
                </v-row>

                <!-- <v-divider></v-divider> -->
                <v-row no-gutters class="d-flex mb-1 justify-space-between flex-md-and-down-column" align="center">
                  <v-col class="d-flex justify-space-around" style="border-top: 1px solid rgba(0, 0, 0, 0.08); border-left: 1px solid rgba(0, 0, 0, 0.08); border-right: 1px solid rgba(0, 0, 0, 0.08); border-bottom: 1px solid rgba(0, 0, 0, 0.08)">
                      <Chip :open="open" description="Online" :value="getOperadoresOnline(queue.fila_id)"
                        colorSecondaryChip="blue darken-1" />
                      <Chip :open="open" description="Disponíveis" :value="getOperadoresLivres(queue.fila_id)"
                        colorSecondaryChip="green darken-1" />
                      <Chip :open="open" description="Ocupados" :value="getOperadoresOcupados(queue.fila_id)"
                        colorSecondaryChip="red darken-1" />
                      <Chip :open="open" description="Pausados" :value="getOperadoresPausados(queue.fila_id)"
                        colorSecondaryChip="amber darken-1" />
                      <Chip :open="open" class="chip-calls-on-wait mr-2" description="Lig. em Espera"
                        :value="getCallsOnWaitByQueue(queue.fila_id).length" colorSecondaryChip="orange darken-1" />
                    <!-- <v-divider class="mt-3 mr-3" vertical></v-divider> -->
                  </v-col>
                  <!-- <v-divider></v-divider> -->
                  <v-col class="d-flex justify-space-around" style="border-top: 1px solid rgba(0, 0, 0, 0.08); border-left: 1px solid rgba(0, 0, 0, 0.08); border-right: 1px solid rgba(0, 0, 0, 0.08); border-bottom: 1px solid rgba(0, 0, 0, 0.08)">
                      <Chip description="Ligações" :value="queue.total" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="Atendidas" :value="queue.atendidas" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="Abandonadas" :value="queue.Abandonadas" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="Transbordo" :value="queue.timeout" colorSecondaryChip="grey darken-1"
                        :open="open" />
                    <!-- <v-divider class="mt-3 mr-3" vertical></v-divider> -->
                  </v-col>
                  <v-col class="d-flex justify-space-around" style="border-top: 1px solid rgba(0, 0, 0, 0.08); border-left: 1px solid rgba(0, 0, 0, 0.08); border-right: 1px solid rgba(0, 0, 0, 0.08); border-bottom: 1px solid rgba(0, 0, 0, 0.08)">
                  <!-- <v-divider></v-divider> -->
                      <Chip  class="text-center" description="TMC" :value="queue.mediaTempoDeChamada" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="TMA" :value="queue.mediaTempoDeAtendimento" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="TME" :value="queue.mediaEspera" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="TMAB" :value="queue.mediaAbandono" colorSecondaryChip="grey darken-1"
                        :open="open" />
                      <Chip description="Serviço" :value="`${queue.nivelServico} | ${queue.tempoNivelServico}s`"
                        colorSecondaryChip="grey darken-1" :open="open" class="ml-2"/>
                  </v-col>
                </v-row>
              </div>
            </template>
            <template v-slot:actions>
              <v-icon color="orangePcm">$expand</v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <MonitorRamaisCallCenter :idFila="queue.fila_id" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  import Chip from '../_components/Chip'

  import MonitorRamaisCallCenter from './MonitorRamaisCallCenter'

  export default {
    name: 'ExpansionPanel',
    props: {
      arrayInfoQueues: Array,
      showSkeleton: Boolean,
    },
    components: {
      MonitorRamaisCallCenter,
      Chip
    },
    // components: { MonitorRamaisCallCenter },
    data: () => ({
      panel: [],
      // headers: [
      //       { text: 'Online', value: 'online' },
      //       { text: 'Disponíveis', value: 'disponiveis' },
      //       { text: 'Ocupados', value: 'ocupados' },
      //       { text: 'Pausados', value: 'pausados' },
      //       { text: 'Em espera', value: 'ligacoesEmEspera' },
      //       { text: 'Ligações', value: 'ligacoes' },
      //       { text: 'Atendidas', value: 'atendidas' },
      //       { text: 'Abandonadas', value: 'abandonadas' },
      //       { text: 'Trasbordo', value: 'transbordo' },
      //       { text: 'Serviço', value: 'servico' },
      //       { text: 'TMC', value: 'tmc' },
      //       { text: 'TMA', value: 'tma' },
      //       { text: 'TME', value: 'tme' },
      //       { text: 'TMB', value: 'tmb' },
      //     ],
      //     desserts: [
      //       {
      //         online: '2',
      //         disponiveis: '2',
      //         ocupados: '0',
      //         pausados: '0',
      //         ligacoesEmEspera: '0',
      //         ligacoes: '0',
      //         atendidas: '0',
      //         abandonadas: '0',
      //         transbordo: '0',
      //         servico: '0% 12',
      //         tmc: '00:00:00',
      //         tma: '00:00:00',
      //         tmb: '00:00:00',
      //         tme: '00:00:00',
      //       },
      //     ]
    }),

    computed: {
      ...mapGetters([
        'getRamais',
        'getCallsOnWaitByQueue',
        'getOperadoresLivres',
        'getOperadoresOnline',
        'getOperadoresOcupados',
        'getOperadoresPausados',
      ]),
    },

    methods: {
      ...mapActions(['prevCall', 'nextCall', 'resetCall']),

      ramaisCardsFilaEspecifica(idFila) {
        let ramaisFilaEspecifica = []

        this.getRamais.forEach(ramal => {
          if (typeof ramal.arrayQueues !== 'undefined') {
            const indexQueue = ramal.arrayQueues.findIndex(idQueue => idQueue === idFila)

            if (indexQueue !== -1) {
              ramaisFilaEspecifica.push(ramal)
            }
          }
        })

        return ramaisFilaEspecifica
      },
    },
  }
</script>

<style scoped>
  .title-operators {
    font-size: 18px;
    text-align: center;
    font-weight: bold;
  }
</style>